import type { Fact } from "@averagejoesff/shared";

interface FactListProps {
  facts: Fact[];
  heading?: string;
}

/**
 * The report's narrative bullets: the fact's emoji where it has one, a
 * neutral dot otherwise. `tone` isn't drawn — the emoji already carries it.
 */
export function FactList({ facts, heading }: FactListProps) {
  if (facts.length === 0) return null;
  return (
    <div className="fact-list">
      {heading && <h4 className="fact-list__heading">{heading}</h4>}
      <ul className="fact-list__items">
        {facts.map((fact, i) => (
          <li key={i} className="fact-list__item">
            <span className={`fact-list__marker${fact.emoji ? "" : " fact-list__marker--dot"}`} aria-hidden="true">
              {fact.emoji ?? "•"}
            </span>
            <span>{fact.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
